import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { ApiHelper } from './apiHelper';

@Injectable()
export class SocketService extends Socket {
  constructor(private apiHelper: ApiHelper) {
    super({ url: apiHelper.getServiceName('data'), options: { transports: ['websocket'] } });
  }
}
